var _a, _b;
import { RenderSectionType, RenderPageType } from "./render-theme.models";
export var AllRenderDevices = ["mobile", "tablet", "desktop"];
/**
 * Display version of a variant within its section type: the first variant of a type is V1, the next V2,
 * and so on in catalog order. Append a new variant after the others of its type so existing numbers hold.
 */
export function variantVersion(v) {
    if (!v) {
        return 0;
    }
    return RenderVariantCatalog.filter(function (c) { return c.type === v.type; }).indexOf(v) + 1;
}
export function variantPages(v) {
    return v && v.pages && v.pages.length ? v.pages : [RenderPageType.Lobby];
}
/** Devices a section renders on (all when unrestricted). */
export function variantDevices(v) {
    return v && v.devices && v.devices.length ? v.devices : AllRenderDevices;
}
export function variantColorPrefix(v, page) {
    if (v && v.colorPrefixByPage && v.colorPrefixByPage[page]) {
        return v.colorPrefixByPage[page];
    }
    return v ? v.colorPrefix : null;
}
/** All colour-token prefixes a section owns on a page (a section may span several token namespaces). */
export function variantColorPrefixes(v, page) {
    if (v && v.colorPrefixes && v.colorPrefixes.length) {
        return v.colorPrefixes;
    }
    var single = variantColorPrefix(v, page);
    return single ? [single] : [];
}
export var RenderVariantCatalog = [
    // Template 7 - the default variant for each section type.
    { id: "fold-t7", type: RenderSectionType.Fold, isDefault: true },
    { id: "advert-t7", type: RenderSectionType.Advert, isDefault: true, imageProps: true,
        pages: [RenderPageType.Lobby, RenderPageType.Cart, RenderPageType.Results, RenderPageType.Purchases, RenderPageType.Bundle, RenderPageType.Syndicate, RenderPageType.Lottery,
            RenderPageType.Lotteries, RenderPageType.Bundles] },
    // Stories + Banners are hidden on desktop (template-7 lobby.scss `@include media-md { display:none }`).
    { id: "stories-t7", type: RenderSectionType.Stories, isDefault: true, devices: ["mobile", "tablet"] },
    // Lotteries Carousel is hidden below desktop (display:none, shown only at `@include media-md`).
    { id: "lotteries-carousel-t7", type: RenderSectionType.LotteriesCarousel, isDefault: true, devices: ["desktop"] },
    { id: "scratch-cards-carousel-t7", type: RenderSectionType.ScratchCardsCarousel, isDefault: true, requiresCapability: "instantGames", itemImages: "instantGame" },
    { id: "banners-t7", type: RenderSectionType.Banners, isDefault: true, devices: ["mobile", "tablet"] },
    { id: "lotteries-grid-t7", type: RenderSectionType.LotteriesGrid, isDefault: true },
    { id: "instant-game-cards-t7", type: RenderSectionType.InstantGameCards, isDefault: true, requiresCapability: "instantGames", itemImages: "instantGame" },
    { id: "bundles-t7", type: RenderSectionType.Bundles, isDefault: true, requiresCapability: "bundles" },
    { id: "instant-games-t7", type: RenderSectionType.InstantGames, isDefault: true, requiresCapability: "instantGames", itemImages: "instantGame" },
    { id: "latest-results-t7", type: RenderSectionType.LatestResults, isDefault: true },
    { id: "banners-t3", type: RenderSectionType.Banners },
    { id: "latest-results-t3", type: RenderSectionType.LatestResults },
    { id: "how-to-play-t3", type: RenderSectionType.HowToPlay },
    { id: "lotteries-grid-t9", type: RenderSectionType.LotteriesGrid },
    { id: "fold-t1", type: RenderSectionType.Fold },
    { id: "banners-t1", type: RenderSectionType.Banners },
    { id: "lotteries-grid-t1", type: RenderSectionType.LotteriesGrid },
    { id: "latest-results-t1", type: RenderSectionType.LatestResults },
    { id: "lotteries-grid-t10", type: RenderSectionType.LotteriesGrid },
    { id: "banners-custom", type: RenderSectionType.Banners, imageProps: true,
        pages: [RenderPageType.Lobby, RenderPageType.Cart, RenderPageType.Results, RenderPageType.Purchases, RenderPageType.Bundle, RenderPageType.Syndicate,
            RenderPageType.Lotteries, RenderPageType.Bundles] },
    { id: "lotteries-cart-t7", type: RenderSectionType.LotteriesCart, isDefault: true,
        pages: [RenderPageType.Cart], colorPrefix: "cart-lotteries-cart-" },
    { id: "lotteries-cart-t3", type: RenderSectionType.LotteriesCart,
        pages: [RenderPageType.Cart], colorPrefix: "cart-lotteries-cart-" },
    { id: "hottest-lotteries-t7", type: RenderSectionType.HottestLotteries, isDefault: true,
        pages: [RenderPageType.Cart, RenderPageType.Results, RenderPageType.Purchases], colorPrefix: "cart-hottest-lotteries-",
        colorPrefixByPage: (_a = {}, _a[RenderPageType.Cart] = "cart-hottest-lotteries-", _a[RenderPageType.Results] = "results-hottest-lotteries-", _a[RenderPageType.Purchases] = "purchases-hottest-lotteries-", _a) },
    { id: "results-list-t7", type: RenderSectionType.LotteriesResults, isDefault: true,
        pages: [RenderPageType.Results], colorPrefix: "results-lotteries-" },
    { id: "lotteries-purchases-t7", type: RenderSectionType.LotteriesPurchases, isDefault: true,
        pages: [RenderPageType.Purchases], colorPrefix: "purchases-lotteries-" },
    { id: "bundle-details-t7", type: RenderSectionType.BundleDetails, isDefault: true,
        pages: [RenderPageType.Bundle], colorPrefix: "bundle-details-" },
    { id: "bundle-details-t3", type: RenderSectionType.BundleDetails,
        pages: [RenderPageType.Bundle], colorPrefix: "bundle-details-" },
    { id: "bundle-game-information-t7", type: RenderSectionType.BundleGameInformation, isDefault: true,
        pages: [RenderPageType.Bundle], colorPrefix: "bundle-game-information-" },
    { id: "syndicate-lotteries-carousel-t7", type: RenderSectionType.SyndicateLotteriesCarousel, isDefault: true,
        pages: [RenderPageType.Syndicate] },
    { id: "syndicate-banner-t7", type: RenderSectionType.SyndicateBanner, isDefault: true,
        pages: [RenderPageType.Syndicate], colorPrefix: "syndicate-banner-" },
    { id: "syndicate-banner-switch", type: RenderSectionType.SyndicateBanner,
        pages: [RenderPageType.Syndicate] },
    { id: "syndicates-carousel-t7", type: RenderSectionType.SyndicatesCarousel, isDefault: true,
        pages: [RenderPageType.Syndicate], colorPrefix: "syndicate-carousel-" },
    { id: "syndicate-details-t7", type: RenderSectionType.SyndicateDetails, isDefault: true,
        pages: [RenderPageType.Syndicate], colorPrefix: "syndicate-details-" },
    { id: "syndicate-details-t3", type: RenderSectionType.SyndicateDetails,
        pages: [RenderPageType.Syndicate], colorPrefix: "syndicate-step-" },
    { id: "lottery-lotteries-carousel-t7", type: RenderSectionType.LotteryLotteriesCarousel, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-carousel-lotteries-" },
    { id: "lottery-switch-pages-t7", type: RenderSectionType.LotterySwitchPages, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-switch-pages-", requiresCapability: "syndicate" },
    { id: "lottery-subscription-banner-t7", type: RenderSectionType.LotterySubscriptionBanner, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-banner-subscription-", requiresCapability: "subscription" },
    { id: "lottery-choose-tickets-t7", type: RenderSectionType.LotteryChooseTickets, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefixes: [
            "lottery-header-lottery-", "lottery-ticket-", "lottery-bonus-", "lottery-choose-ticket-button-",
            "lottery-choose-tickets-", "lottery-quick-pick-", "lottery-button-add-lines-", "lottery-button-remove-lines-",
            "lottery-draw-", "lottery-mobile-ticket-", "lottery-purchase-tickets-",
            "lottery-free-ticket-", "lottery-free-tickets-"
        ] },
    { id: "lottery-choose-tickets-t3", type: RenderSectionType.LotteryChooseTickets,
        pages: [RenderPageType.Lottery], colorPrefixes: [
            "lottery-header-lottery-", "lottery-ticket-", "lottery-bonus-", "lottery-choose-ticket-button-",
            "lottery-choose-tickets-", "lottery-quick-pick-", "lottery-button-add-lines-", "lottery-button-remove-lines-",
            "lottery-draw-", "lottery-mobile-ticket-", "lottery-purchase-tickets-",
            "lottery-free-ticket-", "lottery-free-tickets-"
        ] },
    { id: "lottery-game-information-t7", type: RenderSectionType.LotteryGameInformation, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-game-information-" },
    { id: "lottery-game-information-t3", type: RenderSectionType.LotteryGameInformation,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-game-information-" },
    { id: "lottery-banner-t3", type: RenderSectionType.LotteryBanner, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-banner-" },
    { id: "lottery-prize-breakdown-t3", type: RenderSectionType.LotteryPrizeBreakdown, isDefault: true,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-prize-breakdown-" },
    { id: "lotteries-list-t7", type: RenderSectionType.LotteriesList, isDefault: true,
        pages: [RenderPageType.Lotteries], colorPrefix: "lotteries-" },
    { id: "bundles-list-t7", type: RenderSectionType.BundlesList, isDefault: true,
        pages: [RenderPageType.Bundles], colorPrefix: "bundles-", requiresCapability: "bundles" },
    { id: "hottest-lotteries-lottery", type: RenderSectionType.HottestLotteries,
        pages: [RenderPageType.Lottery], colorPrefix: "lottery-hottest-lotteries-",
        colorPrefixByPage: (_b = {}, _b[RenderPageType.Lottery] = "lottery-hottest-lotteries-", _b) }
];
export function findRenderVariant(id) {
    return RenderVariantCatalog.filter(function (v) { return v.id === id; })[0] || null;
}
